import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ButtonRectangleRadioGroup } from '@yme/atoms/button-select';
import { NA_VALUE } from '@yme/common/constants';
import { setFilterOptions, getProductValueByOption } from '@yme/pdp-components/ProductCard';
import { getProductVariantsByColorWithGroupingProducts, getProductStandardTransmissionLocaleName, getProduct35KWPowerLocaleName, } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { getMotoScootersValues, getSortedProductVariationsValues } from '../helpers';
import { TRANSMISSION_VERSION_DATA_TEST_ID, TRANSMISSION_VERSION_FILTER_KEY } from './constants';
import { getAvailableSkuBase } from './helpers';
export function SelectTransmission({ isMobileView, productFilterOptions, variantsOfProduct, }) {
    const productTransmissionVersionValues = useSelector(getProductValueByOption(TRANSMISSION_VERSION_FILTER_KEY));
    const productVariantsByColor = useSelector(getProductVariantsByColorWithGroupingProducts);
    const transmissionStandardName = useSelector(getProductStandardTransmissionLocaleName);
    const powerVersion35kwName = useSelector(getProduct35KWPowerLocaleName);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const { sku, power = '', transmission = '', loweredVersion = '', colorItemIndex = 0, } = productFilterOptions;
    const onSelectNewValue = useCallback((value) => {
        if (value && transmission !== value) {
            const currentVariant = getAvailableSkuBase({
                colorVariants: variantsOfProduct,
                power,
                transmission: value,
                loweredVersion,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    // set main prop
                    transmission: value,
                    // set relative options
                    sku: currentVariant.sku,
                    power: currentVariant.power,
                    loweredVersion: currentVariant.loweredVersion,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, loweredVersion, power, sku, transmission, variantsOfProduct]);
    const isCurrentFilterExist = Boolean(productTransmissionVersionValues && productTransmissionVersionValues?.length);
    if (transmission && isCurrentFilterExist && transmission !== NA_VALUE) {
        const transmissionPossibleOptions = powerVersion35kwName === power
            ? productVariantsByColor?.[colorItemIndex]?.transmission35KwPossibleOptions
            : productVariantsByColor?.[colorItemIndex]?.transmissionFullPowerPossibleOptions;
        const possibleOptions = (productVariantsByColor && transmissionPossibleOptions) || [];
        const formattedProductTransmissionValues = getMotoScootersValues(productTransmissionVersionValues);
        const sortedProductTransmissionValues = getSortedProductVariationsValues(formattedProductTransmissionValues, transmissionStandardName);
        const formattedPossibleOptions = getMotoScootersValues(possibleOptions);
        return (React.createElement(FlexWrapper, { mt: "20px", flexDirection: "column" },
            React.createElement(FlexWrapper, { mb: "8px" },
                React.createElement(RegularTextLevel3, { weight: 500 }, t('productCard_transmission_label'))),
            React.createElement(FlexWrapper, { flexDirection: isMobileView ? 'column' : 'row', gap: "12px" },
                React.createElement(ButtonRectangleRadioGroup, { contentTag: RegularTextLevel4, setActiveOption: onSelectNewValue, allOptions: sortedProductTransmissionValues, possibleOptions: formattedPossibleOptions, selectedValue: transmission, dataTestId: TRANSMISSION_VERSION_DATA_TEST_ID, isRadioVisible: true }))));
    }
    return null;
}
